// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1oTBR","colMin":"styles_colMin__2O3N0"};